import { ActionTree } from 'vuex'

import { SlogState, RootState } from '@/types/store'
import { ISlog, SlogParams } from '@/types/slog'

import { createLog, getLogs } from '@/api/slogs'

export const actions: ActionTree<SlogState, RootState> = {
  async createLog(_, log: ISlog): Promise<void> {
    await createLog(log)
  },
  async getLogs({ commit }, params: SlogParams): Promise<void> {
    commit('setIsLogsLoading', true)
    const logs = await getLogs(params)
    commit('setIsLogsLoading', false)
    commit('logsLoaded', logs)
  },
}
